import styles from './styles.module.scss';
import { Props } from './types';

const MenuButton = ({
  menuItem,
  activeItem,
  onChange,
  imgSrc,
  label,
  isDisabled = false,
}: Props) => {
  const handleClick = () => {
    if (!isDisabled) {
      onChange(menuItem);
    }
  };

  return (
    <div
      className={[
        styles.item,
        activeItem === menuItem && styles.active,
        isDisabled && styles.disabled,
      ].join(' ')}
      onClick={handleClick}
    >
      <img
        src={imgSrc}
        className={[
          styles.icon,
          activeItem === menuItem && styles.activeIcon,
        ].join(' ')}
      />
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default MenuButton;
